// extracted by mini-css-extract-plugin
module.exports = {"formGroup":"PartnerJoinInput_formGroup__guN9e","formControl":"PartnerJoinInput_formControl__hdNTk","error":"PartnerJoinInput_error__EsfDf"};